"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggletipLinkStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _createFocusRingStyles = require("../../../util/createFocusRingStyles");
var _withFocusClassName = require("../../../util/withFocusClassName");
const ToggletipLinkStyled = (0, _withFocusClassName.withFocusToggleClassName)((0, _styled.default)("a")(_ref => {
  let {
    themeMode
  } = _ref;
  return `
        color: inherit;
        font-size: inherit;
        line-height:inherit;
        font-weight: inherit;

        // Elide if the link is too wide. We just need a non-inline type here.
        display: inline-grid;
        // IE11 hack
        display: -ms-inline-flexbox;
        vertical-align: bottom;

        ${(0, _createFocusRingStyles.createFocusRingStyles)({
    colorOverride: "currentColor",
    innerColorOverride: "transparent",
    theme: themeMode,
    componentBorderWidth: 0,
    componentRadius: 0,
    gap: 1,
    focusSelector: ":focus-visible"
  })}
    `;
}));
exports.ToggletipLinkStyled = ToggletipLinkStyled;
ToggletipLinkStyled.displayName = "ToggletipLinkStyled";
//# sourceMappingURL=ToggletipLinkStyled.js.map